import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=04f39d88&"
import script from "./TabPane.vue?vue&type=script&lang=js&"
export * from "./TabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f39d88')) {
      api.createRecord('04f39d88', component.options)
    } else {
      api.reload('04f39d88', component.options)
    }
    module.hot.accept("./TabPane.vue?vue&type=template&id=04f39d88&", function () {
      api.rerender('04f39d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/tabs/TabPane.vue"
export default component.exports